module.exports = __webpack_public_path__ + "static/media/16_profile_picture.ef827cb0.png";